var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-body" }, [
    _c("form", { staticClass: "mb-4" }, [
      _c("div", { staticClass: "input-group input-group-merge" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search",
            },
          ],
          staticClass: "form-control form-control-prepended",
          attrs: { type: "search", placeholder: "Tìm theo tỉnh, thành phố" },
          domProps: { value: _vm.search },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.search = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "my-n3" }, [
      _vm.regions.length > 0
        ? _c(
            "div",
            { staticClass: "list-group list-group-flush" },
            _vm._l(_vm.filteredRegions, function (region) {
              return _c(
                "a",
                {
                  staticClass:
                    "list-group-item d-flex justify-content-between align-items-center px-0",
                  attrs: {
                    href: _vm.$root.url("orn_web_cinema_region", {
                      slug: region.slug,
                    }),
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.doChangeRegion(region, $event)
                    },
                  },
                },
                [
                  _c("h4", { staticClass: "text-body mb-0" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(region.name) +
                        "\n                    "
                    ),
                    _c(
                      "span",
                      { staticClass: "small text-muted d-block mt-1" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(region.total_cinemas) +
                            " " +
                            _vm._s(
                              _vm.$root.translate("label.num_of_cinemas")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isSelectedRegion(region)
                    ? _c("span", { staticClass: "text-danger" }, [
                        _c("i", { staticClass: "fe fe-check-circle" }),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("div", { staticClass: "input-group-text" }, [
        _c("span", { staticClass: "fe fe-search" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }